/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

/** @module components/default-layout */
import baustein from "baustein";
/**
 * This no-op component is used for layouts that we don't know how to render on the client.
 * @constructor
 * @alias module:components/default-layout
 * @extends module:baustein
 */
export default baustein.register("default-layout", {
    // DON'T ADD ANYTHING HERE
});

